import {AxiosResponse} from "axios";
import {PageableModel} from "../../common/models/table";
import {Api, apiUrls} from "../../helpers/api";
import {PlaceOwnedVehicleModel} from "../models/placeOwnedVehicle";
import http from "../../common/services/httpService";

export class PlaceOwnedVehicleService {
    public static async getAll(): Promise<AxiosResponse<PageableModel<PlaceOwnedVehicleModel>>> {
        return await http.get<PageableModel<PlaceOwnedVehicleModel>>(Api.getUrl(apiUrls.place.ownedVehicles));
    }
}